import { render, staticRenderFns } from "./situacaoFrotaReportModel.vue?vue&type=template&id=02a2d782&scoped=true"
import script from "./situacaoFrotaReportModel.vue?vue&type=script&lang=js"
export * from "./situacaoFrotaReportModel.vue?vue&type=script&lang=js"
import style0 from "./situacaoFrotaReportModel.vue?vue&type=style&index=0&id=02a2d782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a2d782",
  null
  
)

export default component.exports